import UploadPosterIcon from 'components/icons/upload-poster/index.vue'
import AnimationProcessing from 'components/animations/processing'
import {UploadObject} from 'src/utils/objects/uploader'
import Errors from 'src/utils/helper/errors'

export default {
  name: 'uploader',

  components: {
    UploadPosterIcon,
    AnimationProcessing
  },

  data () {
    return {
      uploader: UploadObject(),
      errorbanner: false
    }
  },
  created () {
  },
  props: {
    imgPriority: Number,
    foundryId: String,
    isimageUpdateText: {
      type: Boolean,
      default: false
    },
    isNewimageUploadText: {
      type: Boolean,
      default: false
    },
    islogoUploadText: {
      type: Boolean,
      default: false
    },
    bannerError: {
      type: String,
      default: ''
    },
    logoError : {
      type: String,
      default: ''
    },
    bannerUploadError : {
      type: String
    },
    texttoDisplay: String
  },
  computed: {
  },

  methods: {
    setUploader () {
      let $0 = this
      if (this.$el.querySelector('#qq-foundry-uploader-zone')) {
        this.uploader.create({
          context: this,
          target: '#qq-foundry-uploader-zone',
          handle: function () {
            let uploads = $0.uploader.getSubmits()
            if (uploads.length > 1) {
              $0.showError()
              return false
            }
            const option = {
              foundryId: $0.foundryId,
              file: uploads[0].file,
              priority: $0.imgPriority
            }
            $0.$emit('imageUploadCall', option)
          }
        })
      }
    },
    showError () {
      let err = Errors.create({
        message: this.$t('pages.profile.foundry_image_upload_limit')
      })
      this.$store.dispatch('errors/throw', err)
    }
  },

  mounted () {
    this.setUploader()
    if (this.isNewimageUploadText) {
      if (document.getElementById('bannerImg')) {
        let w = document.getElementById('bannerImg').clientHeight
        document.querySelector('#newfoundry-uploader-banner-choose').style.height = w + 'px'
      } else if(document.getElementById('withoutBannerImg')) {
        let w = document.getElementById('withoutBannerImg').clientHeight
        document.querySelector('#newfoundry-uploader-banner-choose').style.height = w + 'px'
      }
    }
  },

  updated () {
    /*
     * Make sure the uploader is resetted in Template after render update.
     */
    this.setUploader()
    if(this.bannerError){
      document.querySelector('#bannerwarning').style.display = 'none'
    }
  }
}
